var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0516351B-1EAE-42A7-AF8C-7F344BC1D182") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,16 L1,16 C0.45,16 0,16.45 0,17 L0,18 C0,18.55 0.45,19 1,19 L6,19 C6.55,19 7,18.55 7,18 L7,17 C7,16.45 6.55,16 6,16 L6,16 Z M1,18 L6,18 L6,17 L1,17 L1,18 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,12 L1,12 C0.45,12 0,12.45 0,13 L0,14 C0,14.55 0.45,15 1,15 L10,15 C10.55,15 11,14.55 11,14 L11,13 C11,12.45 10.55,12 10,12 L10,12 Z M1,14 L10,14 L10,13 L1,13 L1,14 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8 L1,8 C0.45,8 0,8.45 0,9 L0,10 C0,10.55 0.45,11 1,11 L12,11 C12.55,11 13,10.55 13,10 L13,9 C13,8.45 12.55,8 12,8 L12,8 Z M1,10 L12,10 L12,9 L1,9 L1,10 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 L1,4 C0.45,4 0,4.45 0,5 L0,6 C0,6.55 0.45,7 1,7 L16,7 C16.55,7 17,6.55 17,6 L17,5 C17,4.45 16.55,4 16,4 L16,4 Z M1,6 L16,6 L16,5 L1,5 L1,6 Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0 L1,0 C0.45,0 0,0.45 0,1 L0,2 C0,2.55 0.45,3 1,3 L19,3 C19.55,3 20,2.55 20,2 L20,1 C20,0.45 19.55,0 19,0 L19,0 Z M1,2 L19,2 L19,1 L1,1 L1,2 Z",
    id: "Fill-9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarChart);
export default __webpack_public_path__ + "static/media/HorizontalBarChart.6d907ee510936086e14991193adae29b.svg";
export { ForwardRef as ReactComponent };